/*
 * Copyright (C) 2020 Airfordable, Inc - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

const globalWindow = (global as any).window;

export default () => {
  if (global && globalWindow && globalWindow.navigator) {
    const userAgent =
      globalWindow.navigator.userAgent ||
      globalWindow.navigator.vendor ||
      globalWindow.opera;

    const isIos = /iPad|iPhone|iPod/.test(userAgent) && !globalWindow.MSStream;
    const isAndroid = /android/i.test(userAgent);

    return {
      isAndroid,
      isIos,
      isMobile: isIos || isAndroid,
      unKnownDevice: !isIos && !isAndroid,
    };
  }

  return {};
};
